import { render, staticRenderFns } from "./ClassReminders.vue?vue&type=template&id=35fd97a2&scoped=true&"
import script from "./ClassReminders.vue?vue&type=script&lang=js&"
export * from "./ClassReminders.vue?vue&type=script&lang=js&"
import style0 from "./ClassReminders.vue?vue&type=style&index=0&id=35fd97a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fd97a2",
  null
  
)

export default component.exports